import { OrderingExample, Ordering2Example, IndividualExample, AdditiveExample } from "../../../../src/components/transformadditive/examples";
import * as React from 'react';
export default {
  OrderingExample,
  Ordering2Example,
  IndividualExample,
  AdditiveExample,
  React
};